import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal, WordReveal } from '../components/Motion';
import { workCategories } from '../mock/work-categories';

const Hero = ({ tag, title, subtitle }) => (
  <section className="px-6 md:px-12 lg:px-20 pt-32 pb-16 relative overflow-hidden">
    <div
      className="blob"
      style={{ width: 500, height: 500, background: 'var(--accent)', top: '-20%', right: '-10%', opacity: 0.12 }}
    />
    <div className="max-w-[1500px] mx-auto relative">
      <span className="section-eyebrow">{tag}</span>
      <h1 className="h-display mt-8 text-[12vw] md:text-[8.5vw]">
        <WordReveal text={title} />
      </h1>
      <p className="mt-8 max-w-2xl text-muted text-[15px] leading-relaxed">{subtitle}</p>
    </div>
  </section>
);

const CategoryCard = ({ category, index }) => (
  <Reveal delay={index * 0.06}>
    <Link
      to={category.path}
      data-testid={`work-category-${category.id}`}
      data-cursor="hover"
      className="group block card-prem overflow-hidden h-full"
    >
      <div className="relative aspect-[5/4] overflow-hidden">
        <img
          src={category.cover}
          alt={category.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1400ms]"
        />
        <div
          className="absolute inset-0"
          style={{ background: 'linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.65))' }}
        />
        <div className="absolute top-5 left-5 text-[11px] uppercase tracking-widest text-accent">
          {category.count}
        </div>
      </div>
      <div className="p-7 flex items-start justify-between gap-4">
        <div>
          <h3 className="h-display text-2xl md:text-3xl">{category.title}</h3>
          <p className="text-muted text-[13.5px] mt-3 max-w-md leading-relaxed">{category.desc}</p>
          <span className="link-arrow mt-6 inline-flex">
            Explore <span className="arrow"><ArrowUpRight size={14} /></span>
          </span>
        </div>
        <ArrowUpRight
          size={20}
          className="text-dim group-hover:text-accent transition-colors flex-shrink-0 mt-1"
        />
      </div>
    </Link>
  </Reveal>
);

export default function Work() {
  return (
    <div data-testid="work-overview-page">
      <Hero
        tag="Work — categories"
        title="the workshop."
        subtitle="A curated overview of everything I make — product design, websites, illustration and digital art. Pick a discipline below to dive into the dedicated portfolio."
      />
      <section className="px-6 md:px-12 lg:px-20 pb-32">
        <div className="max-w-[1500px] mx-auto">
          <div className="grid md:grid-cols-2 gap-8 md:gap-10">
            {workCategories.map((c, i) => (
              <CategoryCard key={c.id} category={c} index={i} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
